export const queryCookieName = '_query_url_share_'
